<footer class="app-footer">
  <div class="footer-content">
    <div class="footer-section">
      <div class="footer-brand">
        <mat-icon class="footer-logo">emoji_events</mat-icon>
        <span class="footer-title">{{ 'nav.title' | transloco }}</span>
      </div>
      <p class="footer-description">
        {{ 'nav.description' | transloco }}
      </p>
    </div>

    <div class="footer-section">
      <h4 class="footer-heading">{{ 'nav.quickLinks' | transloco }}</h4>
      <ul class="footer-links">
        <li>
          <a href="/" class="footer-link">{{ 'nav.home' | transloco }}</a>
        </li>
        <li>
          <a href="/settings" class="footer-link">{{ 'nav.settings' | transloco }}</a>
        </li>
      </ul>
    </div>

    <div class="footer-section">
      <h4 class="footer-heading">{{ 'nav.support' | transloco }}</h4>
      <ul class="footer-links">
        <li>
          <span class="footer-text">{{ 'nav.contactAdmin' | transloco }}</span>
        </li>
        <li>
          <span class="footer-text">{{ 'nav.systemStatus' | transloco }}: {{ 'nav.online' | transloco }}</span>
        </li>
      </ul>
    </div>
  </div>

  <div class="footer-bottom">
    <div class="footer-copyright">
      <span>{{ 'nav.copyright' | transloco: { currentYear: currentYear } }}</span>
      @if (hasKudos()) {
        <button mat-button class="footer-discreet-link" (click)="openKudosDialog()">
          {{ 'nav.kudos' | transloco }}
        </button>
      }
    </div>
    <div class="footer-version">
      <details class="version-text" title="Environment Info">
        <summary class="meta-summary">Environment Info</summary>
        <div class="meta-content">
          <span class="meta-item">
            <span class="meta-label">Environment:</span>
            <span class="meta-value meta-env">{{ versionInfo.environment }}</span>
          </span>
          <span class="meta-item">
            <span class="meta-label">Execution Mode:</span>
            <span class="meta-value">{{ executionMode }}</span>
          </span>
          <span class="meta-item">
            <span class="meta-label">Semantic Version:</span>
            <span class="meta-value">{{ semanticVersion }}</span>
          </span>
          <span class="meta-item">
            <span class="meta-label">Commit Hash:</span>
            <span class="meta-value">{{ commitHash }}</span>
          </span>
          <span class="meta-item">
            <span class="meta-label">Docker Tag:</span>
            <span class="meta-value">{{ dockerTag }}</span>
          </span>
          <span class="meta-item">
            <span class="meta-label">Platform:</span>
            <span class="meta-value">{{ platformVersion }}</span>
          </span>
        </div>
      </details>
    </div>
  </div>
</footer>
